export default {
  EDIT: 'edit',
  CLEAR: 'clear',
  BULKEDIT: 'bulkedit',
};
